import { Router } from '@angular/router';

export function currentRoute(router: Router | null): string {
	return router?.url ?? globalThis.location?.pathname ?? '';
}
